import { useEffect, useState } from "react";

/** Ladezustand in der Form des Inhalts. Erscheint erst nach 300 ms, damit schnelle Antworten nicht flackern. */
export function Skeleton({ lines = 3, thumb = false, label = "Wird geladen …" }: { lines?: number; thumb?: boolean; label?: string }) {
  const [sichtbar, setSichtbar] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setSichtbar(true), 300);
    return () => clearTimeout(t);
  }, []);
  if (!sichtbar) return <div role="status" aria-live="polite" className="rg-sr">{label}</div>;
  return (
    <div className="rg-skel" role="status" aria-live="polite" aria-label={label}>
      {Array.from({ length: lines }, (_, i) => (
        <div className="rg-skel__row" key={i}>
          {thumb ? <div className="rg-skel__thumb" /> : null}
          <div className="rg-skel__lines">
            <span className="rg-skel__bar" style={{ width: `${70 - (i % 3) * 15}%` }} />
            <span className="rg-skel__bar rg-skel__bar--sm" style={{ width: `${40 + (i % 2) * 20}%` }} />
          </div>
        </div>
      ))}
    </div>
  );
}
